function dynamicFooterDirective($bbug) {
    'ngInject';

    return function (scope, el, attrs) {

        scope.$on('page:loaded', () => $bbug('.content').css('height', 'auto'));

        scope.$watch(() => $bbug('.content')[0].scrollHeight,
            (new_val, old_val) => {
                if (new_val !== old_val) {
                    return scope.setContentHeight();
                }
            });

        scope.setContentHeight = function () {
            $bbug('.content').css('height', 'auto');
            const content_height = $bbug('.content')[0].scrollHeight;
            const min_content_height = $bbug(window).innerHeight() - $bbug('.content').offset().top - $bbug('.footer').height();
            if (content_height < min_content_height) {
                return $bbug('.content').css('height', min_content_height + 'px');
            }
        };

        $bbug(window).on('resize', () => scope.setContentHeight());
    };
}

angular
    .module('BB')
    .directive('bbDynamicFooter', dynamicFooterDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/dynamic-footer/dynamic_footer.directive.js